'use client';

import { c as _c } from "react/compiler-runtime";
import { NavArrowDown } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import type { ItineraryCardBodyProps } from './ItineraryCard.types';
import styles from './ItineraryCardBody.module.css';
const DEFAULT_TRUNCATE_LENGTH = 200;
export function ItineraryCardBody(t0) {
  const $ = _c(14);
  const {
    text,
    truncateAt: t1,
    disableTruncate: t2
  } = t0;
  const truncateAt = t1 === undefined ? DEFAULT_TRUNCATE_LENGTH : t1;
  const disableTruncate = t2 === undefined ? false : t2;
  const tCommon = useTranslations("common");
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text) {
    return null;
  }
  const isLong = !disableTruncate && text.length > truncateAt;
  let t3;
  if ($[0] !== isExpanded || $[1] !== isLong || $[2] !== text || $[3] !== truncateAt) {
    t3 = isLong && !isExpanded ? `${text.slice(0, truncateAt)}…` : text;
    $[0] = isExpanded;
    $[1] = isLong;
    $[2] = text;
    $[3] = truncateAt;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const displayText = t3;
  let t4;
  if ($[5] !== displayText) {
    t4 = <p className={styles.text}>{displayText}</p>;
    $[5] = displayText;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isExpanded || $[8] !== isLong || $[9] !== tCommon) {
    t5 = isLong ? <button type="button" className={styles.toggle} onClick={() => setIsExpanded(_temp)} aria-expanded={isExpanded}><span className={styles.toggleLabel}>{isExpanded ? tCommon("read_less") : tCommon("read_more")}</span><span className={`${styles.toggleIcon} ${isExpanded ? styles.toggleIconExpanded : ""}`.trim()}><NavArrowDown decorative={true} size="small" /></span></button> : null;
    $[7] = isExpanded;
    $[8] = isLong;
    $[9] = tCommon;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles.body}>{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(prev) {
  return !prev;
}